import { Card, CardContent, CardHeader, CardTitle, Text } from '@careflux/primitives';
import type { MetricTileProps } from './components.types';
import { SUPPRESSED_LABEL } from './formatting';

export const MetricTile = ({ title, value, detail, suppressed = false }: MetricTileProps) => (
  <Card gap="sm">
    <CardHeader>
      <CardTitle>
        <Text size="sm" color="muted">
          {title}
        </Text>
      </CardTitle>
    </CardHeader>
    <CardContent>
      {suppressed ? (
        <Text size="sm" color="muted">
          {SUPPRESSED_LABEL}
        </Text>
      ) : (
        <Text size="2xl" weight="bold" className="tabular-nums">
          {value}
        </Text>
      )}
      {detail ? (
        <Text asChild size="xs" color="muted">
          <p>{detail}</p>
        </Text>
      ) : null}
    </CardContent>
  </Card>
);
